<div class="wrap">


  <div class="header">
    <div class="title">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active" appChangeColorTheme attribute="color"></fa-icon>
      <h2>{{title}}</h2>
    </div>

  </div>


  <section *ngIf="!isLoading">
    <form [formGroup]="dateForm" (ngSubmit)="onSubmit()" *ngIf="dateForm">
      <mat-form-field appearance="outline" class="dateField">
        <mat-label>Date de départ</mat-label>
        <input matInput [matDatepicker]="startDatePicker" formControlName="startDate">
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="dateField">
        <mat-label>Date de fin</mat-label>
        <input matInput [matDatepicker]="endDatePicker" [min]="dateForm.value.startDate" formControlName="endDate">
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>

      <fa-icon class="search_button" [icon]="getFaIcon('faSearch')" appChangeColorTheme
      attribute="color" (click)="onSubmit()" [matTooltip]="getTooltip('doSearch')"></fa-icon>
    </form>
  </section>


  <section [hidden]="planings.length === 0 || isLoading">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

      <ng-container matColumnDef="clubRessourcePseudo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Pseudo (Nom Prénom)</th>
        <td mat-cell *matCellDef="let session"> {{ session.clubRessourcePseudo }} ({{session.clubRessourceFirstName}} {{session.clubRessourceLastName}}) </td>
      </ng-container>

      <ng-container matColumnDef="dateLib">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Session </th>
        <td mat-cell *matCellDef="let session">{{ session.dateLib}} </td>
      </ng-container>

      <ng-container matColumnDef="offerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Offre </th>
        <td mat-cell *matCellDef="let session"> {{ session.offerName }} </td>
      </ng-container>

      <ng-container matColumnDef="sessionStartDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de début </th>
        <td mat-cell *matCellDef="let session"> {{ session.sessionStartDate}} </td>
      </ng-container>

      <ng-container matColumnDef="sessionEndDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de fin </th>
        <td mat-cell *matCellDef="let session"> {{ session.sessionEndDate}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header-row"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row">
      </tr>
    </table>
    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
    (page)="pageEvent = $event" [color]="color">
</mat-paginator>
  </section>

  <mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>

  <ng-container *ngIf="planings.length === 0 && !isLoading">
    <p>Il n'y a pas de ressources allouées à ces dates.</p>
  </ng-container>

  </div>
